module.exports = __webpack_public_path__ + "img/manual_arrow_1.1153136a.png";